import React, { Component } from 'react';
import Select from 'react-select';
import { Button } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { getDmService, updateDmService } from '../../../services/Api';
import StepCard from '../../StepCard';
import UnidAndStores from '../UnitsAndStores';

class Cleark extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsCleark: [],
      stores: [],
    };
  }

  componentWillMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({ nivel });

    this.searchTrade();
  }

  searchTrade = () => {
    const urlGet = '/Atendente/BuscaAtendentes/?busca=&tipoAssistente=1';
    getDmService(urlGet)
      .then((res) => {
        res.map(item => this.setState(prevState => ({
          optionsCleark: [...prevState.optionsCleark, { id: item.id, label: item.nome }],
        })));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  update = () => {
    const { selectedItemSearch, data, selectedStore } = this.props;
    const item = data.itensAssistente[0];
    const formData = {
      Atendente: { Id: selectedItemSearch.id },
      Loja: { Id: selectedStore.id },
    };

    updateDmService('/Pedido/EditaAssistente', item.id, formData)
      .then(() => {
        toast.success('Atendente atualizado com sucesso');
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar atualizar o dado de atendente.');
      });
  };

  cancel = () => {
    this.stepCardRef.toggleContent();
  };

  selectedUniform(obj, id) {
    this.setState(prevState => ({
      ...prevState,
      dataRequest: {
        ...prevState.dataRequest,
        [id]: obj.label,
      },
    }));
  }

  renderComponent() {
    const { data } = this.props;

    return (
      <p>
        <strong>
          {data.atendente && data.atendente.nome}
          {' '}
          -
          {' '}
        </strong>
        {' '}
        {data.itensAssistente[0].loja.nomeFantasia}
      </p>
    );
  }

  render() {
    const {
      isFinished,
      dataClerck,
      selectedItemSearch,
      changeSelected,
      selectedStore,
      selectedUnit,
      onChangeUnit,
      onChangeStore,
      stores,
      nivel
    } = this.props;

    const { optionsCleark } = this.state;
    return (
      <StepCard
        onRef={(ref) => {
          this.stepCardRef = ref;
        }}
        title="Atendente"
        description={this.renderComponent(dataClerck)}
        isFinished={isFinished}
      >
        <div className="search-clearck">
          <div className="search-typed">
            <Select
              value={selectedItemSearch}
              label="Digite o nome do atendente."
              placeholder="Digite o nome da atendente"
              options={optionsCleark}
              onChange={e => changeSelected(e)}
              className="search-dm"
            />
          </div>
        </div>
        <div className="bx--row mg-top-20">
          <div className="bx--col-md-12">
            <UnidAndStores
              onChangeStore={onChangeStore}
              onChangeUnit={onChangeUnit}
              stores={stores}
              urlUnits={`/Atendente/GetUnidades/${dataClerck.id}`}
              selectedUnit={selectedUnit}
              selectedStore={selectedStore}
            />
          </div>
        </div>
        <br />
        <br />
        <div className="v-md-margin mg-top-40">
          {nivel === 10 && (<Button onClick={this.update}>Salvar</Button>)}
          <Button kind="ghost" className="h-sm-margin" onClick={this.cancel}>
            Cancelar
          </Button>
        </div>
      </StepCard>
    );
  }
}

export default Cleark;



// WEBPACK FOOTER //
// ./src/components/trades/uniforms/Clerk.js